/**
 * @param {object | undefined | null} deepDiveResults
 * @returns {boolean}
 */
function canCancelPartnerOrder(deepDiveResults) {
    if (!deepDiveResults) {
        return false;
    }

    const status = String(deepDiveResults.fbmPartnerOrderIngestStatus ?? '').toUpperCase();
    if (status !== 'DEFERRED' && status !== 'PENDING') {
        return false;
    }

    const { mmOrderNum } = deepDiveResults;
    const hasMmOrder = mmOrderNum != null && mmOrderNum !== '' && Number(mmOrderNum) !== 0;
    const hasShipments = (deepDiveResults.shipmentInfo?.length ?? 0) > 0;

    return !hasMmOrder && !hasShipments;
}

export { canCancelPartnerOrder };
